//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qs from 'qs'

export default {
  name: 'm-login',
  data () {
    return {
      holderPhone: '',
      holderPhoneCAPTCHA: '',
      CAPTCHACountdown: 0
    }
  },
  computed: {
    show2 () {
      return this.showLogin
    },
    CAPTCHALabel () {
      if (this.CAPTCHACountdown === 0) {
        return '获取'
      }
      return this.CAPTCHACountdown + '秒'
    }
  },
  props: ['showLogin'],
  methods: {
    onCancel () {
      this.$emit('close')
    },
    onConfirm () {
      if (!this.checkHolderPhone() || !this.checkHolderPhoneCAPTCHA()) return
      // 发送Ajax请求
      const data = {
        'phoneNum': this.holderPhone,
        'messageValidCode': this.holderPhoneCAPTCHA
      }
      this.$http.post('/api/user/bind', qs.stringify(data)).then(response => {
        console.log(response.data)
        if (response.data.result === 'true') {
          this.$vux.toast.show({
            type: 'text',
            text: '客官，登录成功',
            position: 'top',
            width: '20em'
          })
          this.$emit('close')
        } else {
          this.$vux.toast.show({
            type: 'text',
            text: '客官，请输入正确的验证码',
            position: 'top',
            width: '20em'
          })
        }
      })
    },
    sendCAPTCHA () {
      if (this.checkHolderPhone()) {
        const that = this
        this.$http.get('/api/common/getvalidatecodeForH5').then(response => {
          let sendMessageCode = '/api/common/sendMessageCodeDefault/' + response.data + '/' + this.holderPhone
          this.$http.get(sendMessageCode)
            .then(response => {
              console.log(response.data)
              if (response.data.statusCode === '000000') {
                that.CAPTCHACountdown = 60
                const CAPTCHATimer = setInterval(() => {
                  if (that.CAPTCHACountdown === 0) {
                    clearInterval(CAPTCHATimer)
                  } else {
                    that.CAPTCHACountdown--
                  }
                }, 1000)
              } else {
                this.$vux.toast.show({
                  type: 'text',
                  text: '客官，获取验证码失败',
                  position: 'top',
                  width: '20em'
                })
              }
            })
        })
      }
    },
    checkHolderPhone () {
      if (this.holderPhone === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入手机号',
          position: 'top',
          width: '20em'
        })
        return false
      }
      if (!/^1[34578]\d{9}$/.test(this.holderPhone)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入正确的手机号',
          position: 'top',
          width: '20em'
        })
        return false
      }
      return true
    },
    checkHolderPhoneCAPTCHA () {
      if (this.holderPhoneCAPTCHA === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入验证码',
          position: 'top',
          width: '20em'
        })
        return false
      }
      if (!/^\d{4}$/.test(this.holderPhoneCAPTCHA)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入正确的验证码',
          position: 'top',
          width: '20em'
        })
        return false
      }
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login.vue